import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'
import { DatePickerModule } from 'primeng/datepicker'
import { UserModel } from '../../../../core/models/user.model'

@Component({
  selector: 'app-route-date-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    DatePickerModule,
  ],
  templateUrl: './route-date-selector.component.html',
  styleUrls: ['./route-date-selector.component.scss'],
})
export class RouteDateSelectorComponent {
  @Input() visible: boolean = false
  @Input() technician: UserModel | null = null
  @Input() selectedDate: Date | null = null
  @Input() minDate: Date = new Date()
  @Input() maxDate: Date = new Date()
  @Input() visibleStartDate: Date = new Date()
  @Input() visibleEndDate: Date = new Date()

  @Output() visibleChange = new EventEmitter<boolean>()
  @Output() selectedDateChange = new EventEmitter<Date | null>()
  @Output() generateRoute = new EventEmitter<void>()

  hide(): void {
    this.visible = false
    this.visibleChange.emit(false)
  }

  onGenerateRoute(): void {
    this.generateRoute.emit()
  }

  onDateChange(date: Date): void {
    this.selectedDate = date
    this.selectedDateChange.emit(date)
  }
}
